<mat-card class="summary-card week">
	<div class="summary-title week">WEEK TO DATE</div>
	<div class="summary-content">
		<div class="summary-metric">
			<span class="metric-label">SALES</span>
			<span class="metric-value">{{ weekSalesTop | currency:'USD':'symbol':'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="weekSalesBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">LABOUR %</span>
			<span class="metric-value">{{ weekLabourPerTop }}</span>
			<span class="metric-sub" [innerHTML]="weekLabourPerBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">ONLINE SALES</span>
			<span class="metric-value">{{ weekOnlineSalesTop | currency:'USD':'symbol':'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="weekOnlineSalesBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">ONLINE CUSTOMER ORDERS</span>
			<span class="metric-value">{{ weekOnlineCustomerOrdersTop | number:'1.0-0'}}</span>
			<span class="metric-sub" [innerHTML]="weekOnlineCustomerOrdersBottom"></span>
		</div>
		@if (this.shopType!="DT") {
		<div class="summary-metric">
			<span class="metric-label">DRIVE-THRU SALES</span>
			<span class="metric-value">{{ weekDriveThruSalesTop | currency:'USD':'symbol':'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="weekDriveThruSalesBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">DRIVE-THRU ORDERS</span>
			<span class="metric-value">{{ weekDriveThruOrdersTop | number:'1.0-0'}}</span>
			<span class="metric-sub" [innerHTML]="weekDriveThruOrdersBottom"></span>
		</div>
		}
		<div class="summary-metric">
			<span class="metric-label">TARGET</span>
			<span class="metric-value">{{ weekTargetTop | currency:'USD':'symbol':'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="weekTargetBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">LABOUR HOURS</span>
			<span class="metric-value">{{ weekLabourHoursTop | number:'1.0-0'}}</span>
			<span class="metric-sub" [innerHTML]="weekLabourHoursBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">CUSTOMER ORDERS</span>
			<span class="metric-value">{{ weekCustomerOrdersTop | number:'1.0-0'}}</span>
			<span class="metric-sub" [innerHTML]="weekCustomerOrdersBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">LABOUR COST</span>
			<span class="metric-value">{{ weekLabourCostTop | currency:'USD':'symbol':'1.0-0'}}</span>
			<span class="metric-sub" [innerHTML]="weekLabourCostBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">ITEM SOLD</span>
			<span class="metric-value">{{ weekItemsSoldTop | number:'1.0-0' }}</span>
			<span class="metric-sub" [innerHTML]="weekItemsSoldBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">SALES / LABOUR HOUR</span>
			<span class="metric-value">{{ weekSalesByLabourHourTop | currency:'USD':'symbol':'1.2-2' }}</span>
			<span class="metric-sub" [innerHTML]="weekSalesByLabourHourBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">SALES VALUE / ITEM</span>
			<span class="metric-value">{{ weekSalesValueByItemTop | currency:'USD':'symbol':'1.2-2' }}</span>
			<span class="metric-sub" [innerHTML]="weekSalesValueByItemBottom"></span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">AVERAGE ORDER $</span>
			<span class="metric-value">{{ weekAverageOrderTop | currency:'USD':'symbol':'1.2-2' }}</span>
			<span class="metric-sub" [innerHTML]="weekAverageOrderBottom"></span>
		</div>
	</div>
</mat-card>